import request from '@/utils/request'

export const getProductionrecordList = ({ page, size, keywords: materialName }) => {
  return request({
    url: `/trace/productionrecord/${page}/${size}`,
    params: {
      materialName
    }
  })
}

export const postProductionrecordEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/productionrecord',
    data
  })
}

export const putProductionrecordAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/productionrecord',
    data
  })
}

export const getProductionrecordDetail = (id) => {
  return request({
    url: `/trace/productionrecord/${id}`
  })
}

// 预生成生产记录号
export const getProductionrecordCode = (params) => {
  return request({
    url: '/trace/productionrecord/recordCode',
    params
  })
}

export const deleteProductionrecordDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/productionrecord/${id}`
  })
}

export const delProductionrecordList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/productionrecord/all',
    data
  })
}
